// src/app/store.ts
import { configureStore } from "@reduxjs/toolkit";
import uIReducer from "./reducers/uiReducer";
import userReducer from "./reducers/userReducer";
import hardmoneyReducer from "./reducers/hardmoneyReducer";
import { socketMiddleware } from "./utils/socketMiddleware";

export const store = configureStore({
    reducer: {
        ui: uIReducer,
        user: userReducer,
        hardmoney: hardmoneyReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(socketMiddleware),
});

// Define the RootState and AppDispatch types for use throughout your app
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
